import React, { Fragment } from "react";
import "./ShareTrackingTransport.scss";

import { useTranslation } from "react-i18next";
import { IoMdArrowDropdown } from "react-icons/io";
import { Tooltip } from "@mui/material";
import moment from "moment";
import "moment/locale/ka";
import "moment/locale/en-gb";
import "moment/locale/ru";
import "moment/locale/uz";

const ShareTrackingTransport = ({ order }) => {
  const { t } = useTranslation();
  const pickUpDate = order?.cargos?.[0]?.pickup_date
    ? moment(order?.cargos?.[0]?.pickup_date).format("MMM Do")
    : "-";

  const trailerType = order?.cargos?.[0]?.trailerType?.name || "-";
  const trailersize = order?.cargos?.[0]?.trailersize?.label || "-";
  const temperature = order?.cargos?.[0]?.temperature || "-";
  const packingType = order?.cargos?.[0]?.packing_type?.name || "-";

  const RenderTransportTooltip = () => {
    const RenderItem = ({ item }) => {
      const itemtrailerType = item?.trailerType?.name || "-";
      const itemtrailersize = item?.trailersize?.label || "-";
      const itemtemperature = item?.temperature || "-";
      const packingType = item.packing_type?.name || "-";

      return (
        <div className='TrailerInfoCardMain'>
          {order?.type_group?.id === 1 ? (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='30'
              height='24'
              viewBox='0 0 30 24'
              fill='none'
            >
              <g clipPath='url(#clip0_10535_6162)'>
                <path
                  d='M29.25 15H25.5V3.75C25.5 3.55109 25.421 3.36032 25.2803 3.21967C25.1397 3.07902 24.9489 3 24.75 3H0.75C0.551088 3 0.360322 3.07902 0.21967 3.21967C0.0790176 3.36032 0 3.55109 0 3.75L0 17.25C0 17.4489 0.0790176 17.6397 0.21967 17.7803C0.360322 17.921 0.551088 18 0.75 18H3.07547C3.4425 15.4589 5.60672 13.5 8.25 13.5C10.8933 13.5 13.0575 15.4589 13.4245 18H29.25C29.4489 18 29.6397 17.921 29.7803 17.7803C29.921 17.6397 30 17.4489 30 17.25V15.75C30 15.5511 29.921 15.3603 29.7803 15.2197C29.6397 15.079 29.4489 15 29.25 15ZM4.5 11.4225C3.96639 11.6909 3.46345 12.0164 3 12.3933V6.375C3 6.27554 3.03951 6.18016 3.10984 6.10983C3.18016 6.03951 3.27554 6 3.375 6H4.125C4.22446 6 4.31984 6.03951 4.39016 6.10983C4.46049 6.18016 4.5 6.27554 4.5 6.375V11.4225ZM9 10.5534C8.75109 10.5305 8.50453 10.5 8.25 10.5C7.99547 10.5 7.74891 10.5305 7.5 10.5534V6.375C7.5 6.27554 7.53951 6.18016 7.60983 6.10983C7.68016 6.03951 7.77554 6 7.875 6H8.625C8.72446 6 8.81984 6.03951 8.89017 6.10983C8.96049 6.18016 9 6.27554 9 6.375V10.5534ZM13.5 12.3933C13.0366 12.0164 12.5336 11.6909 12 11.4225V6.375C12 6.27554 12.0395 6.18016 12.1098 6.10983C12.1802 6.03951 12.2755 6 12.375 6H13.125C13.2245 6 13.3198 6.03951 13.3902 6.10983C13.4605 6.18016 13.5 6.27554 13.5 6.375V12.3933ZM18 15H16.5V6.375C16.5 6.27554 16.5395 6.18016 16.6098 6.10983C16.6802 6.03951 16.7755 6 16.875 6H17.625C17.7245 6 17.8198 6.03951 17.8902 6.10983C17.9605 6.18016 18 6.27554 18 6.375V15ZM22.5 15H21V6.375C21 6.27554 21.0395 6.18016 21.1098 6.10983C21.1802 6.03951 21.2755 6 21.375 6H22.125C22.2245 6 22.3198 6.03951 22.3902 6.10983C22.4605 6.18016 22.5 6.27554 22.5 6.375V15ZM8.25 15C7.50832 15 6.7833 15.2199 6.16661 15.632C5.54993 16.044 5.06928 16.6297 4.78545 17.3149C4.50162 18.0002 4.42736 18.7542 4.57206 19.4816C4.71675 20.209 5.0739 20.8772 5.59835 21.4016C6.1228 21.9261 6.79098 22.2833 7.51841 22.4279C8.24584 22.5726 8.99984 22.4984 9.68506 22.2145C10.3703 21.9307 10.956 21.4501 11.368 20.8334C11.7801 20.2167 12 19.4917 12 18.75C12 17.7554 11.6049 16.8016 10.9017 16.0983C10.1984 15.3951 9.24456 15 8.25 15ZM8.25 20.25C7.95333 20.25 7.66332 20.162 7.41665 19.9972C7.16997 19.8324 6.97771 19.5981 6.86418 19.324C6.75065 19.0499 6.72094 18.7483 6.77882 18.4574C6.8367 18.1664 6.97956 17.8991 7.18934 17.6893C7.39912 17.4796 7.66639 17.3367 7.95736 17.2788C8.24834 17.2209 8.54994 17.2506 8.82403 17.3642C9.09811 17.4777 9.33238 17.67 9.4972 17.9166C9.66203 18.1633 9.75 18.4533 9.75 18.75C9.75 19.1478 9.59196 19.5294 9.31066 19.8107C9.02936 20.092 8.64782 20.25 8.25 20.25Z'
                  fill='#878A99'
                />
              </g>
              <defs>
                <clipPath id='clip0_10535_6162'>
                  <rect width='30' height='24' fill='white' />
                </clipPath>
              </defs>
            </svg>
          ) : (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
            >
              <g clipPath='url(#clip0_8715_73088)'>
                <path
                  d='M21.333 20H2.66634C2.31272 20 1.97358 19.8595 1.72353 19.6095C1.47348 19.3594 1.33301 19.0203 1.33301 18.6667V5.33333C1.33301 4.97971 1.47348 4.64057 1.72353 4.39052C1.97358 4.14048 2.31272 4 2.66634 4H21.333C21.6866 4 22.0258 4.14048 22.2758 4.39052C22.5259 4.64057 22.6663 4.97971 22.6663 5.33333V18.6667C22.6663 19.0203 22.5259 19.3594 22.2758 19.6095C22.0258 19.8595 21.6866 20 21.333 20ZM2.66634 5.33333V18.6667H21.333V5.33333H2.66634Z'
                  fill='#878A99'
                />
                <path
                  d='M6.00013 16.8661C5.85868 16.8661 5.72303 16.81 5.62301 16.7099C5.52299 16.6099 5.4668 16.4743 5.4668 16.3328V7.66615C5.4668 7.5247 5.52299 7.38904 5.62301 7.28902C5.72303 7.189 5.85868 7.13281 6.00013 7.13281C6.14158 7.13281 6.27723 7.189 6.37725 7.28902C6.47727 7.38904 6.53346 7.5247 6.53346 7.66615V16.3328C6.53346 16.4743 6.47727 16.6099 6.37725 16.7099C6.27723 16.81 6.14158 16.8661 6.00013 16.8661Z'
                  fill='#878A99'
                />
                <path
                  d='M9.94642 16.8661C9.80497 16.8661 9.66932 16.81 9.5693 16.7099C9.46928 16.6099 9.41309 16.4743 9.41309 16.3328V7.66615C9.41309 7.5247 9.46928 7.38904 9.5693 7.28902C9.66932 7.189 9.80497 7.13281 9.94642 7.13281C10.0879 7.13281 10.2235 7.189 10.3235 7.28902C10.4236 7.38904 10.4798 7.5247 10.4798 7.66615V16.3328C10.4798 16.4743 10.4236 16.6099 10.3235 16.7099C10.2235 16.81 10.0879 16.8661 9.94642 16.8661Z'
                  fill='#878A99'
                />
                <path
                  d='M14.0001 16.8661C13.8587 16.8661 13.723 16.81 13.623 16.7099C13.523 16.6099 13.4668 16.4743 13.4668 16.3328V7.66615C13.4668 7.5247 13.523 7.38904 13.623 7.28902C13.723 7.189 13.8587 7.13281 14.0001 7.13281C14.1416 7.13281 14.2772 7.189 14.3773 7.28902C14.4773 7.38904 14.5335 7.5247 14.5335 7.66615V16.3328C14.5335 16.4743 14.4773 16.6099 14.3773 16.7099C14.2772 16.81 14.1416 16.8661 14.0001 16.8661Z'
                  fill='#878A99'
                />
                <path
                  d='M18.0001 16.8661C17.8587 16.8661 17.723 16.81 17.623 16.7099C17.523 16.6099 17.4668 16.4743 17.4668 16.3328V7.66615C17.4668 7.5247 17.523 7.38904 17.623 7.28902C17.723 7.189 17.8587 7.13281 18.0001 7.13281C18.1416 7.13281 18.2772 7.189 18.3773 7.28902C18.4773 7.38904 18.5335 7.5247 18.5335 7.66615V16.3328C18.5335 16.4743 18.4773 16.6099 18.3773 16.7099C18.2772 16.81 18.1416 16.8661 18.0001 16.8661Z'
                  fill='#878A99'
                />
              </g>
              <defs>
                <clipPath id='clip0_8715_73088'>
                  <rect width='24' height='24' fill='white' />
                </clipPath>
              </defs>
            </svg>
          )}
          <div className='TrailerInfoCardDesc'>
            {order?.type_group?.id === 3 ? (
              <Fragment>
                {item?.packing_type ? (
                  <h4 className='TrailerInfoTypeText'>
                    {packingType}
                    {item?.temperature && <span>- {itemtemperature}</span>}
                  </h4>
                ) : (
                  "-"
                )}
              </Fragment>
            ) : (
              <Fragment>
                {item?.trailerType ? (
                  <h4 className='TrailerInfoTypeText'>
                    {itemtrailerType} {item?.trailersize?.label && <span>- {itemtrailersize}</span>}{" "}
                    {item?.temperature && <span>- {itemtemperature}</span>}
                  </h4>
                ) : (
                  "-"
                )}
              </Fragment>
            )}

            {item?.transport && (
              <div className='TrailerInfoTransport'>
                <p className='TrailerInfoTransportText'>{item?.transport?.number || "-"}</p>
              </div>
            )}
          </div>
        </div>
      );
    };

    return (
      <div className='list'>
        {order?.cargos &&
          order?.cargos?.length > 0 &&
          order?.cargos.map((item, index) => <RenderItem key={index} item={item} />)}
      </div>
    );
  };

  return (
    <div id='ShareTrackingTransport'>
      <div className='TrailerInfoCard'>
        <div className='TrailerInfoCardMain'>
          {order?.type_group?.id === 1 ? (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='30'
              height='24'
              viewBox='0 0 30 24'
              fill='none'
            >
              <g clipPath='url(#clip0_10535_6162)'>
                <path
                  d='M29.25 15H25.5V3.75C25.5 3.55109 25.421 3.36032 25.2803 3.21967C25.1397 3.07902 24.9489 3 24.75 3H0.75C0.551088 3 0.360322 3.07902 0.21967 3.21967C0.0790176 3.36032 0 3.55109 0 3.75L0 17.25C0 17.4489 0.0790176 17.6397 0.21967 17.7803C0.360322 17.921 0.551088 18 0.75 18H3.07547C3.4425 15.4589 5.60672 13.5 8.25 13.5C10.8933 13.5 13.0575 15.4589 13.4245 18H29.25C29.4489 18 29.6397 17.921 29.7803 17.7803C29.921 17.6397 30 17.4489 30 17.25V15.75C30 15.5511 29.921 15.3603 29.7803 15.2197C29.6397 15.079 29.4489 15 29.25 15ZM4.5 11.4225C3.96639 11.6909 3.46345 12.0164 3 12.3933V6.375C3 6.27554 3.03951 6.18016 3.10984 6.10983C3.18016 6.03951 3.27554 6 3.375 6H4.125C4.22446 6 4.31984 6.03951 4.39016 6.10983C4.46049 6.18016 4.5 6.27554 4.5 6.375V11.4225ZM9 10.5534C8.75109 10.5305 8.50453 10.5 8.25 10.5C7.99547 10.5 7.74891 10.5305 7.5 10.5534V6.375C7.5 6.27554 7.53951 6.18016 7.60983 6.10983C7.68016 6.03951 7.77554 6 7.875 6H8.625C8.72446 6 8.81984 6.03951 8.89017 6.10983C8.96049 6.18016 9 6.27554 9 6.375V10.5534ZM13.5 12.3933C13.0366 12.0164 12.5336 11.6909 12 11.4225V6.375C12 6.27554 12.0395 6.18016 12.1098 6.10983C12.1802 6.03951 12.2755 6 12.375 6H13.125C13.2245 6 13.3198 6.03951 13.3902 6.10983C13.4605 6.18016 13.5 6.27554 13.5 6.375V12.3933ZM18 15H16.5V6.375C16.5 6.27554 16.5395 6.18016 16.6098 6.10983C16.6802 6.03951 16.7755 6 16.875 6H17.625C17.7245 6 17.8198 6.03951 17.8902 6.10983C17.9605 6.18016 18 6.27554 18 6.375V15ZM22.5 15H21V6.375C21 6.27554 21.0395 6.18016 21.1098 6.10983C21.1802 6.03951 21.2755 6 21.375 6H22.125C22.2245 6 22.3198 6.03951 22.3902 6.10983C22.4605 6.18016 22.5 6.27554 22.5 6.375V15ZM8.25 15C7.50832 15 6.7833 15.2199 6.16661 15.632C5.54993 16.044 5.06928 16.6297 4.78545 17.3149C4.50162 18.0002 4.42736 18.7542 4.57206 19.4816C4.71675 20.209 5.0739 20.8772 5.59835 21.4016C6.1228 21.9261 6.79098 22.2833 7.51841 22.4279C8.24584 22.5726 8.99984 22.4984 9.68506 22.2145C10.3703 21.9307 10.956 21.4501 11.368 20.8334C11.7801 20.2167 12 19.4917 12 18.75C12 17.7554 11.6049 16.8016 10.9017 16.0983C10.1984 15.3951 9.24456 15 8.25 15ZM8.25 20.25C7.95333 20.25 7.66332 20.162 7.41665 19.9972C7.16997 19.8324 6.97771 19.5981 6.86418 19.324C6.75065 19.0499 6.72094 18.7483 6.77882 18.4574C6.8367 18.1664 6.97956 17.8991 7.18934 17.6893C7.39912 17.4796 7.66639 17.3367 7.95736 17.2788C8.24834 17.2209 8.54994 17.2506 8.82403 17.3642C9.09811 17.4777 9.33238 17.67 9.4972 17.9166C9.66203 18.1633 9.75 18.4533 9.75 18.75C9.75 19.1478 9.59196 19.5294 9.31066 19.8107C9.02936 20.092 8.64782 20.25 8.25 20.25Z'
                  fill='#878A99'
                />
              </g>
              <defs>
                <clipPath id='clip0_10535_6162'>
                  <rect width='30' height='24' fill='white' />
                </clipPath>
              </defs>
            </svg>
          ) : (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
            >
              <g clipPath='url(#clip0_8715_73088)'>
                <path
                  d='M21.333 20H2.66634C2.31272 20 1.97358 19.8595 1.72353 19.6095C1.47348 19.3594 1.33301 19.0203 1.33301 18.6667V5.33333C1.33301 4.97971 1.47348 4.64057 1.72353 4.39052C1.97358 4.14048 2.31272 4 2.66634 4H21.333C21.6866 4 22.0258 4.14048 22.2758 4.39052C22.5259 4.64057 22.6663 4.97971 22.6663 5.33333V18.6667C22.6663 19.0203 22.5259 19.3594 22.2758 19.6095C22.0258 19.8595 21.6866 20 21.333 20ZM2.66634 5.33333V18.6667H21.333V5.33333H2.66634Z'
                  fill='#878A99'
                />
                <path
                  d='M6.00013 16.8661C5.85868 16.8661 5.72303 16.81 5.62301 16.7099C5.52299 16.6099 5.4668 16.4743 5.4668 16.3328V7.66615C5.4668 7.5247 5.52299 7.38904 5.62301 7.28902C5.72303 7.189 5.85868 7.13281 6.00013 7.13281C6.14158 7.13281 6.27723 7.189 6.37725 7.28902C6.47727 7.38904 6.53346 7.5247 6.53346 7.66615V16.3328C6.53346 16.4743 6.47727 16.6099 6.37725 16.7099C6.27723 16.81 6.14158 16.8661 6.00013 16.8661Z'
                  fill='#878A99'
                />
                <path
                  d='M9.94642 16.8661C9.80497 16.8661 9.66932 16.81 9.5693 16.7099C9.46928 16.6099 9.41309 16.4743 9.41309 16.3328V7.66615C9.41309 7.5247 9.46928 7.38904 9.5693 7.28902C9.66932 7.189 9.80497 7.13281 9.94642 7.13281C10.0879 7.13281 10.2235 7.189 10.3235 7.28902C10.4236 7.38904 10.4798 7.5247 10.4798 7.66615V16.3328C10.4798 16.4743 10.4236 16.6099 10.3235 16.7099C10.2235 16.81 10.0879 16.8661 9.94642 16.8661Z'
                  fill='#878A99'
                />
                <path
                  d='M14.0001 16.8661C13.8587 16.8661 13.723 16.81 13.623 16.7099C13.523 16.6099 13.4668 16.4743 13.4668 16.3328V7.66615C13.4668 7.5247 13.523 7.38904 13.623 7.28902C13.723 7.189 13.8587 7.13281 14.0001 7.13281C14.1416 7.13281 14.2772 7.189 14.3773 7.28902C14.4773 7.38904 14.5335 7.5247 14.5335 7.66615V16.3328C14.5335 16.4743 14.4773 16.6099 14.3773 16.7099C14.2772 16.81 14.1416 16.8661 14.0001 16.8661Z'
                  fill='#878A99'
                />
                <path
                  d='M18.0001 16.8661C17.8587 16.8661 17.723 16.81 17.623 16.7099C17.523 16.6099 17.4668 16.4743 17.4668 16.3328V7.66615C17.4668 7.5247 17.523 7.38904 17.623 7.28902C17.723 7.189 17.8587 7.13281 18.0001 7.13281C18.1416 7.13281 18.2772 7.189 18.3773 7.28902C18.4773 7.38904 18.5335 7.5247 18.5335 7.66615V16.3328C18.5335 16.4743 18.4773 16.6099 18.3773 16.7099C18.2772 16.81 18.1416 16.8661 18.0001 16.8661Z'
                  fill='#878A99'
                />
              </g>
              <defs>
                <clipPath id='clip0_8715_73088'>
                  <rect width='24' height='24' fill='white' />
                </clipPath>
              </defs>
            </svg>
          )}

          <div className='TrailerInfoCardDesc'>
            {order?.type_group?.id === 3 ? (
              <Fragment>
                {order?.cargos?.[0]?.packing_type ? (
                  <h4 className='TrailerInfoTypeText'>
                    {packingType} {order?.cargos?.[0]?.temperature && <span>- {temperature}</span>}
                  </h4>
                ) : (
                  "-"
                )}
              </Fragment>
            ) : (
              <Fragment>
                {order?.cargos?.[0]?.trailerType ? (
                  <h4 className='TrailerInfoTypeText'>
                    {trailerType}{" "}
                    {order?.cargos?.[0]?.trailersize?.label && <span>- {trailersize}</span>}{" "}
                    {order?.cargos?.[0]?.temperature && <span>- {temperature}</span>}
                  </h4>
                ) : (
                  "-"
                )}
              </Fragment>
            )}

            {order?.cargos?.[0]?.transport?.number && (
              <div className='TrailerInfoTransport'>
                <p className='TrailerInfoTransportText'>
                  {order?.cargos?.[0]?.transport?.number || "-"}
                </p>
              </div>
            )}
          </div>
        </div>

        {order?.cargos?.length > 1 && (
          <Tooltip
            placement='bottom'
            title={<RenderTransportTooltip />}
            classes={{ tooltip: "ShareTrackingTransportTooltip" }}
          >
            <div className='TrailerInfoCardTransport'>
              <p>+{order?.cargos?.length - 1}</p>
              <IoMdArrowDropdown />
            </div>
          </Tooltip>
        )}
      </div>
      <p className='takenOrderText'>
        {t("share.The product has been taken")} <span>{pickUpDate}</span>
      </p>
    </div>
  );
};

export default ShareTrackingTransport;
